import { render, staticRenderFns } from "./unboxing.vue?vue&type=template&id=1a061a49&scoped=true"
import script from "./unboxing.vue?vue&type=script&lang=js"
export * from "./unboxing.vue?vue&type=script&lang=js"
import style0 from "./unboxing.vue?vue&type=style&index=0&id=1a061a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a061a49",
  null
  
)

export default component.exports